import React from 'react'
import ContactUs from './Cantact-page/ContactUs'

const Contact = () => {
  return (
     <ContactUs/>
  )
}

export default Contact